var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 448,
    viewBox: "0 0 640 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "upload",
    d: "M144,480A144.038,144.038,0,0,1,96.2,200.1q-.195-4.05-.2-8.1a160.013,160.013,0,0,1,298.7-79.8C409.9,101.1,428.3,96,448,96a95.453,95.453,0,0,1,96,96,97.072,97.072,0,0,1-6.4,34.6A127.992,127.992,0,0,1,512,480Zm79-217c-9.3,9.4-9.3,24.6,0,33.1,9.4,10.2,24.6,10.2,33.1,0L296,257.9V392a24,24,0,0,0,48,0V257.9l39,38.2c9.4,10.2,24.6,10.2,33.1,0,10.2-8.5,10.2-23.7,0-33.1l-80-80c-8.5-9.3-23.7-9.3-33.1,0Z",
    transform: "translate(0 -32)",
    fill: "#f1f1f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7de4efc3678cd36beabfa5deac280f65.svg";
export { ForwardRef as ReactComponent };